import { render } from "./reset-password-form.vue?vue&type=template&id=70e31077"
import script from "./reset-password-form.vue?vue&type=script&lang=js"
export * from "./reset-password-form.vue?vue&type=script&lang=js"

import "./reset-password-form.vue?vue&type=style&index=0&id=70e31077&lang=scss"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__